import "./Card.css";

export function Card({ className, ...props }) {
  return <div className={`Card ${className}`} {...props} />;
}
